const contactForm = document.getElementById('ContactForm');

if (contactForm) {
  if( jQuery('#ContactForm').length ) {
    jQuery("#ContactForm").submit(function () {
        toggleLoadingSpinnerCf(contactForm);
        jQuery("#ContactForm button[type=submit].button").attr("disabled", true);
        return true;
    });
  }
  function toggleLoadingSpinnerCf(formElement) {
    const loadingSpinner = formElement.querySelector(`.loading__spinner`);
    loadingSpinner.classList.toggle('hidden');
  }  
}
